import _ from 'lodash';
import {ENDPOINT_SNAPSHOT} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

// snapshot the data
const postSnapshot = (token, payload) => {
  const id = _.get(payload, 'id');

  const endpointToUse = `${ENDPOINT_SNAPSHOT}${id}`;

  const snapshotReason = _.get(payload, 'snapshotReason');

  let bodyPayload = payload;

  bodyPayload = {
    snapshotReason,
    data: payload,
  };

  return fetch(endpointToUse, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(bodyPayload),
  });
};

export default {
  postSnapshot,
};
